import {Box, Grid, Typography} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import {BasicTable, LargeButton} from '../../components';
import {connect} from 'react-redux';
import {bookSequenceNumber, getPartValidationDetailsForSerialNumber} from '../../redux/actionCreators/partValidation';
import {ERROR_MESSAGE, OPERATIONS, REDIRECT_URLS} from '../../constants';
import {useMessageContextManager} from '../../components/MessageOverlay/MessageOverlay';
import {useRedirectToNextScreen} from '../../hooks';
import {useState} from 'react';
import {ReportModal} from '../../components';
import TakeOut from '../../components/TakeOut/TakeOut';
import MoveToMr from '../../components/MoveToMr/MoveToMr';

const PV_DEFAULT_COLUMNS = [
	{
		width: 300,
		title: 'Vin',
		field: 'serialNumber',
	},
	{
		width: 240,
		title: 'VC Number',
		field: 'parentPartNumber',
	},
	{
		width: 450,
		title: 'VC Description',
		field: 'parentPartDescription',
	},
];

const classNames = {
	paper: {
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
	},
	tableContentContainer: {
		flex: 1,
		backgroundColor: 'background.default',
		borderBottomLeftRadius: '5px',
		borderBottomRightRadius: '5px',
		padding: '20px',
	},
};

const OrderSuccess = ({serialNumber}) => {
	return (
		<>
			<Typography variant='h3' sx={{color: '#82C1A7'}}>
				Booking request for Serial No. / VIN{' '}
				<Typography variant='h3' component='span' fontWeight={700}>
					{serialNumber}
				</Typography>{' '}
				has been initiated successfully
			</Typography>
		</>
	);
};

const mapStateToProps = state => {
	return {
		partValidation: state.partValidation,
	};
};

const mapDispatchToProps = dispatch => ({
	bookSequenceNumber: (sequenceNumber, successCallback, errorCallback) =>
		dispatch(
			bookSequenceNumber(sequenceNumber, successCallback, errorCallback),
		),
});

export const Booking = ({partValidation, bookSequenceNumber}) => {
	const {showMessageOverlay} = useMessageContextManager();
	const redirect = useRedirectToNextScreen();
	const {scanJobDetails} = partValidation;
	const openReportModal = () => setIsReportModalOpen(true);
	const closeReportModal = () => setIsReportModalOpen(false);
	const [isReportModalOpen, setIsReportModalOpen] = useState(false);

	const redirectToHomeScreen = () =>
		redirect(null, {
			operation: OPERATIONS.RECEIVE_PART,
			redirectUrl: REDIRECT_URLS[OPERATIONS.RECEIVE_PART],
		});

	const handleBooking = () => {
		bookSequenceNumber(
			partValidation.sequenceNumber,
			() => {
				const closeOverlay = showMessageOverlay({
					contextText: ' ',
					info: ' ',
					success: true,
					render: () => (
						<OrderSuccess serialNumber={partValidation.serialNumber} />
					),
				});
				setTimeout(() => {
					closeOverlay();
					redirect();
				}, 3000);
			},
			error => {
				showMessageOverlay({
					contextText: ERROR_MESSAGE.ERROR_CONTEXT_TEXT + 'Booking.',
					info: error?.response?.data?.message,
					error: true,
				});
				// logError(`Booking ${error}`);
			},
		);
	};

	return (
		<>
			{/* <BasicTable
				listId='part-validation'
				rows={[{...partValidation}]}
				columns={[...PV_DEFAULT_COLUMNS]}
				defaultColumns={[...PV_DEFAULT_COLUMNS]}
				subtitle='KEY ATTRIBUTES'
				tableStyles={{paper: classNames.paper}}
			>
				<Box sx={classNames.tableContentContainer}>
					<Grid container direction='column' height='100%'>
						<Grid item container flexGrow={1} alignItems='flex-start'>
							<Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
								<CheckIcon
									color='primary'
									sx={{
										fontSize: {
											lg: 34,
										},
									}}
								/>
								<Typography variant='h5' color='primary' fontWeight={400}>
									{partValidation.isExceptionRaised
										? 'Exception Approved. Ready to book.'
										: 'Final part validation completed. Ready to book.'}
								</Typography>
							</Box>
						</Grid>
						<Grid item container alignItems='center' columnSpacing={2}>
							<Grid item container columnSpacing={2} xs={6} textAlign='left'>
								<Grid item>
									<TakeOut redirectToNextScreen={redirectToHomeScreen} partDetails={partValidation} />
								</Grid>
								<Grid item>
									<MoveToMr partDetails={partValidation} />
								</Grid>
								<Grid item>
									<LargeButton
										name='VIEW REPORT'
										handleButtonClick={openReportModal}
									/>
								</Grid>
							</Grid>

							<Grid item xs={6} textAlign='right'>
								<LargeButton
									backgroundColor='#82C1A7'
									name='BOOK'
									handleButtonClick={handleBooking}
								/>
							</Grid>
						</Grid>
					</Grid>
				</Box>
			</BasicTable> */}


			{isReportModalOpen && (
				<ReportModal
					open={isReportModalOpen}
					handleClose={closeReportModal}
					rows={[partValidation]}
					columns={[...PV_DEFAULT_COLUMNS]}
					defaultColumns={[...PV_DEFAULT_COLUMNS]}
					title='PART VALIDATION & GENEALOGY REPORT'
					subtitle='Key Attributes'
					tableStyles={{paper: classNames.paper}}
					scannableParts={scanJobDetails}
				/>
			)}
		</>
	);
};

export default connect(mapStateToProps, mapDispatchToProps)(Booking);
